import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild, Compiler } from '@angular/core';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { FormlyModule, FormlyFieldConfig, FormlyBootstrapModule, Field, FieldWrapper } from 'ng-formly';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LeadService } from '../lead.service';
import { Router } from '@angular/router';


@Component({
    selector: 'app-add-lead',
    templateUrl: './add-lead.component.html',
    styleUrls: ['./add-lead.component.css']
})
export class AddLeadComponent implements OnDestroy {
    @ViewChild('t') t;
    private myDatePickerOptions: IMyDpOptions = {
        // other options...
        // dateFormat: 'dd.mm.yyyy',
        editableDateField: false,
        inline: false,
        componentDisabled: false
    };

    searchLeadForm: FormGroup;
    form: FormGroup = new FormGroup({});
    model: any = {};
    resultData = {};
    resultDataEmpty = true;
    template: Array<any> = [];
    tabs: Array<any> = [];
    values: Array<any> = [];
    templateJSON: Array<any> = [];
    products: Array<any> = [];
    documentArray: Array<any> = [];
    documentArrayIsEmpty = true;
    noResult = false
    documentIndex = 0;
    DocumentTypes = [];
    companyTypes = [];
    productName: '';
    productId: '';
    subProductId: '';
    subproductName: '';
    decision: any = '';
    isProductload;
    isSubProductload = false;
    leadId: '';
    openTabId = '';
    proceedDisabled = false
    tempdate: any;
    otpPop = false;
    otpPopHide = false;
    otp = '';
    leadJSON: any = {
        validationContext: '',
        leadData: {}
    }
    otpSent = false;
    email: ''
    mobile: ''
    leveloneSubmitted = false;
    showCreditInfoButton = true;
    creditScoreResponse: Array<any> = [];
    templateSearch = false;
    creditHistoryFetch: boolean = false
    showCreditScore = false
    NoCreditHistoryFound = false
    submitedData = false;
    documentsEnable = false
    profileImageSrc = 'assets/images/profile_pic.png';
    imageTemplate: any = {
        "className": "section-label",
        "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img class='custImage' style='height:235px; width:235px' src=" + this.profileImageSrc + "></div>"
    }
    trnNo: '';
    subproducts: Array<any> = [];
    private fields: Array<FormlyFieldConfig> = [];
    public minDate: Date = void 0;
    profileIdentifications = [];
    uploadDocObject = {};
    tabButtonTitle = "Proceed";
    activeTabId = "ngb-tab-0";
    docActive = false;
    productParent = 'empty';
    isPopedUp = false;
    isPopedUpHide = false;
    //upload document name Retail start 
    trnDocumentName = '';
    passportDocumentName = '';
    utilityBillDocumentName = '';
    jobLetterDocumentName = '';
    idProofFirstAuthorizedSignatoryName = '';
    idProofSecondAuthorizedSignatoryName = '';
    signedConsentName = '';
    cancelReason = 0;
    cancelRemarks = '';
    //upload document name Retail end
    //upload document name B2B start 
    companyTRNName = "";
    CompanyRegistrationDocName = "";
    CertificateofIncorporationName = "";
    IDofprimaryapplicantName = "";
    SignedConsentFormName = "";

    //upload document name B2B end
    formErrors = {
        'trnNumber': '',
    };
    IsLoaderActive = false;


    constructor(
        private fb: FormBuilder,
        private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private _compiler: Compiler,
        private leadService: LeadService) {
        this.toastr.setRootViewContainerRef(vcr);
        this.form = this.fb.group({
            idType: '',
            trnNumber: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
            firstNameNew: '',
            lastNameNew: '',
            dateOfBirthNew: '',
            B2BCompanyName: '',
            B2BCompanyType: '',
            B2BTrnNumber: '',
            B2BBusinessNumber: '',
        });

        this.searchLeadForm = this.fb.group({
            ProductId: '',
            subProductName: '',
        });

        this.leadService
            .fetchProducts()
            .subscribe((products: any[]) => {
                this.products = products;
                if (this.products) {
                }
            }, error => {

            });
        this.model = {
            'isMailingAddressSameAsAbove': "Yes",
            'nationality': '7ac48140fac845b3b6febf7352061b4e',
            'country': '7ac48140fac845b3b6febf7352061b4e',
            'mailingCountry': '7ac48140fac845b3b6febf7352061b4e',
            'employerCountry': '7ac48140fac845b3b6febf7352061b4e',
            'alternateContactCountry': '7ac48140fac845b3b6febf7352061b4e',
            'additionalCountry': '7ac48140fac845b3b6febf7352061b4e',
        }
        this.minDate = new Date(1950, 1, 1);
    }


    ngOnInit() {
        this.leadService
            .fetchProducts()
            .subscribe((products: any[]) => {
                this.products = products;
                this.isProductload = true;
                if (this.products) {
                }
            }, error => {

            });
    }
    getTemplate(subProductName) {
        // this.activeTabId = "ngb-tab-0";
        // this.model = {}
        // this.imageTemplate = {}
        // this.form.reset()
        // this.leveloneSubmitted = false
        // this.proceedDisabled = true
        // this.showCreditInfoButton = false
        // this.decision = "";
        // this.creditScoreResponse = [];
        // this.template = []
        // this.tabClick("ngb-tab-0")
        this.templateSearch = true;
        var temp2 = this.search(subProductName, this.subproducts)
        this.subProductId = temp2.id
        this.subproductName = temp2.name
        const templateId = this.productName + ':' + this.subproductName
        this.tempdate = this.leadService.fetchTemplateById(templateId).subscribe((template) => {
            this.template = template.templatedata;
            for (var i = 0; i < this.template.length; i++) {
                if (this.template[i]["name"] == "Upload Media") {
                    this.documentArray = this.template[i];
                    for (var j = 0; j < this.documentArray['fields'].length; j++) {
                        this.documentArray['fields'][j]['fileName'] = "";
                    }
                    this.documentIndex = i;
                    this.documentArrayIsEmpty = false;
                }
            }
            this.template.pop();
            this.templateSearch = false;
            if (this.productParent == "B2B") {
                this.trnSearchSetupB2B();
            }
            else if (this.productParent == 'Retail') {
                this.template[0].sections[0].fields[0] = this.imageTemplate;
                this.trnSearchSetup();
            }
            if (!this.documentArrayIsEmpty) {
                this.template.splice(this.documentIndex, 1);
            }
            this.documentArrayIsEmpty = false;

        }, error => {

        });
    }

    isArray = function (a) {
        return (!!a) && (a.constructor === Array);
    };
    trnSearchSetup() {

        // FieldDisabled
        this.template[0].sections[0].fields[1].templateOptions.disabled = true
        this.template[0].sections[0].fields[2].templateOptions.disabled = true
        this.template[0].sections[0].fields[3].templateOptions.disabled = true
        //this.template[0].sections[0].fields[3].templateOptions.readOnly = true;
        this.template[0].sections[0].fields[4].templateOptions.disabled = true
        this.template[0].sections[0].fields[5].templateOptions.disabled = true
        this.template[0].sections[0].fields[5].templateOptions.disabled = true

        this.template[0].sections[2]["fields"][7].templateOptions.disabled = true
        this.template[1]["fields"][10].templateOptions.disabled = true
        this.template[2]["fields"][10].templateOptions.disabled = true
        this.template[0].sections[0].fields[5].templateOptions.disabled = true
        //this.template[0].sections[0].fields[10].templateOptions.maxLength = 10
        this.template[0].active = true
        this.template[1].active = false
        this.template[2].active = false
        this.docActive = false

        this.template[0].sections[0].fields[9].templateOptions.type = "email"
        this.template[0].sections[0].fields[5].templateOptions.required = true
        this.leadService.fetchCountries().subscribe((result) => {
            let masterCountries = [];
            for (var i = 0; i < result.length; i++) {
                if (i == 0) {
                    masterCountries.push({ "label": "Please Select", "value": "" });
                }
                masterCountries.push({ "label": result[i]["name"], "value": result[i]["id"] });
            }
            // this.template[0].sections[2].groups[0].fields[2].templateOptions.options = masterCountries;
            this.template[0].sections[0].fields[5].templateOptions.options = masterCountries;
            this.template[0].sections[2].fields[7].templateOptions.options = masterCountries;
            this.template[1].fields[10].templateOptions.options = masterCountries;
            this.template[2].fields[10].templateOptions.options = masterCountries;
        });
        this.template[0].sections[2].fields[8].templateOptions.label = "Is Mailing Address Same As Above?";
        this.template[0].sections[2].fields[1].templateOptions.label = "Address Line 2";
        // ithe
        this.template[0].sections[2].fields[9].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[10].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[11].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[12].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[13].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[14].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[15].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        this.template[0].sections[2].fields[16].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
        // this.template[0].sections[2].fields[17].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"

    }
    trnSearchSetupB2B() {

        this.template[0].sections[1].groups[1].fields[0].templateOptions.disabled = true
        this.template[0].sections[0].fields[2].templateOptions.disabled = true
        this.template[0].sections[1].groups[1].fields[3].templateOptions.disabled = true



        this.template[0].sections[0].fields[0].templateOptions.label = "Name of Company"
        this.template[0].sections[0].fields[1].templateOptions.label = "Type of Company"

        this.template[0].sections[1].groups[0].fields[0].templateOptions.label = "Street Number and Name";
        this.template[0].sections[1].groups[1].fields[0].templateOptions.label = "Additional Street Number and Name";
        this.template[0].sections[2].fields[2].templateOptions.label = "Is Mailing Address Same As Above?";

        this.docActive = false;

        this.leadService.fetchCountries().subscribe((result) => {
            let masterCountries = [];
            for (var i = 0; i < result.length; i++) {
                if (i == 0) {
                    masterCountries.push({ "label": "Please Select", "value": "" });
                }
                masterCountries.push({ "label": result[i]["name"], "value": result[i]["id"] });
            }
            // this.template[0].sections[2].groups[0].fields[2].templateOptions.options = masterCountries;
            this.template[0].sections[1].groups[0].fields[4].templateOptions.options = masterCountries;
            this.template[0].sections[1].groups[1].fields[4].templateOptions.options = masterCountries;
            this.template[1].fields[10].templateOptions.options = masterCountries;
            this.template[2].fields[10].templateOptions.options = masterCountries;
        });
        this.leadService.fetchStates().subscribe((result) => {
            let masterStates = [];
            for (var i = 0; i < result.length; i++) {
                if (i == 0) {
                    masterStates.push({ "label": "Please Select", "value": "" });
                }
                masterStates.push({ "label": result[i]["name"], "value": result[i]["id"] });
            }
            this.template[1].fields[6].templateOptions.options = masterStates;
            // this.template[0].sections[2].groups[0].fields[2].templateOptions.options = masterCountries;
            this.template[0].sections[1].groups[0].fields[2].templateOptions.options = masterStates;
            this.template[0].sections[1].groups[1].fields[2].templateOptions.options = masterStates;
            this.template[2].fields[6].templateOptions.options = masterStates;
        });
        this.leadService.fetchCities().subscribe((result) => {
            let masterCities = [];
            for (var i = 0; i < result.length; i++) {
                if (i == 0) {
                    masterCities.push({ "label": "Please Select", "value": "" });
                }
                masterCities.push({ "label": result[i]["name"], "value": result[i]["id"] });
            }
            this.template[2].fields[7].templateOptions.options = masterCities;
            this.template[1].fields[7].templateOptions.options = masterCities;
            this.template[0].sections[1].groups[0].fields[1].templateOptions.options = masterCities;
            this.template[0].sections[1].groups[1].fields[1].templateOptions.options = masterCities;
        });
        this.leadService.fetchContactType().subscribe((result) => {
            let masterContacts = [];

            //this.template[0].sections[2].fields[0].templateOptions.options =[];
            for (var i = 0; i < result["ContactType"].length; i++) {

                if (i == 0) {
                    masterContacts.push({ "label": "Please Select", "value": "" });
                }
                masterContacts.push({ "label": result["ContactType"][i]["Description"], "value": result["ContactType"][i]["Value"] });

            }

            this.template[0].sections[2].fields[0].templateOptions.options = masterContacts;
        });
        this.leadService.fetchOccupationType().subscribe((result) => {
            let masterOccupations = [];

            // this.template[1].fields[1].templateOptions.options = [];            
            for (var i = 0; i < result["OccupationType"].length; i++) {
                if (i == 0) {
                    masterOccupations.push({ "label": "Please Select", "value": "" });
                }
                masterOccupations.push({ "label": result["OccupationType"][i]["Description"], "value": result["OccupationType"][i]["Value"] });
            }
            this.template[1].fields[1].templateOptions.options = masterOccupations;
        });
        this.leadService.fetchCompanyType().subscribe((result) => {
            let masterOccupations = [];
            // this.template[0].sections[0].fields[1].templateOptions.options = [];
            for (var i = 0; i < result["CompanyType"].length; i++) {
                if (i == 0) {
                    masterOccupations.push({ "label": "Please Select", "value": "" });
                }
                masterOccupations.push({ "label": result["CompanyType"][i]["Description"], "value": result["CompanyType"][i]["Value"] });
            }
            this.template[0].sections[0].fields[1].templateOptions.options = masterOccupations;
            this.companyTypes = masterOccupations;
        });
        this.leadService.fetchBusinessType().subscribe((result) => {
            let masterOccupations = [];

            // this.template[0].sections[0].fields[4].templateOptions.options = [];
            for (var i = 0; i < result['BusinessType'].length; i++) {
                if (i == 0) {
                    masterOccupations.push({ "label": "Please Select", "value": "" });
                }
                masterOccupations.push({ "label": result['BusinessType'][i]["Description"], "value": result['BusinessType'][i]["Value"] });
            }
            this.template[0].sections[0].fields[4].templateOptions.options = masterOccupations;
        });

    }
    ngOnDestroy() {
        // window.location.reload();
        this._compiler.clearCache();
        this.activeTabId = ''
    }
    getSubProduct(productName) {
        this.isSubProductload = true;
        for (var i = 0; i < this.products.length; i++) {
            if (this.searchLeadForm.value.ProductId == this.products[i]["name"]) {
                this.productParent = this.products[i]["parentName"];
                //this.productParent = "B2B";
            }
        }

        var temp = this.search(productName, this.products)
        this.productName = temp.name
        this.productId = temp.id
        this.leadService.fetchSubproducts(temp.id).subscribe((subproducts: any[]) => {
            this.subproducts = subproducts;
            this.isSubProductload = false;
        }, error => {
            this.isSubProductload = false;
        });
    }
    get_trn_number(obj) {
        //Console.(this.form.value.dateOfBirthNew);
        this.IsLoaderActive = true;

        if (this.productParent == "Retail" || this.productParent == null) {
            if (this.form.value.trnNumber == "" || this.form.value.firstNameNew == "" || this.form.value.lastNameNew == "" || this.form.value.dateOfBirthNew == "" || this.form.value.idType == "") {
                this.toastr.error("Please fill all the mandatory fields.");
                this.IsLoaderActive = false;
                return false;
            }
            if (typeof (this.form.value.dateOfBirthNew) == 'object') {
                let year = this.form.value.dateOfBirthNew['date']["year"].toString();
                let month = this.form.value.dateOfBirthNew['date']["month"].toString().length == 1 ? '0' + this.form.value.dateOfBirthNew['date']["month"].toString() : this.form.value.dateOfBirthNew['date']["month"].toString();
                let day = this.form.value.dateOfBirthNew['date']["day"].toString().length == 1 ? '0' + this.form.value.dateOfBirthNew['date']["day"].toString() : this.form.value.dateOfBirthNew['date']["day"].toString();
                let date = year + '-' + month + '-' + day;
                let birthDate = new Date(date + 'T10:20:30Z');

                var today = new Date();
                //var year = +this.model.dateofBirth.split('-')[0] - today.getFullYear();                
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                else if (m === 0 && today.getDate() == birthDate.getDate()) {
                    age;
                }
                else {
                    age++;
                }
                if (age < 18) {
                    this.toastr.error("Please select date of birth more than 18 years");
                    this.IsLoaderActive = false;
                    return false;
                }
                if (age > 80) {
                    this.toastr.error("Please select date of birth less than 80 years");
                    this.IsLoaderActive = false;
                    return false;
                }
                // if (typeof (this.model.dateOfBirth) == 'object') {
                //     this.model.dateOfBirth = (this.model.dateOfBirth["year"] + '-' + this.model.dateOfBirth["month"] + '-' + + this.model.dateOfBirth["day"]).toString()
                // }
            }
            var responseType = "";
            if (this.form.value.idType.toLowerCase() == "TRN".toLowerCase()) {
                responseType = "TRN"
            }
            else if (this.form.value.idType.toLowerCase() == "Driving License".toLowerCase()) {
                responseType = "DL"
            }
       //     this.model["ResponseType"] = responseType;
            let data = {
                "TRN": this.form.value.trnNumber,
                "ResponseType": responseType
            }
            this.leadService.postTRN(data).subscribe((data) => {
                this.IsLoaderActive = false;
                this.model = data;
                this.model["ResponseType"] = responseType;
                this.openTabId = 'ngb-panel-0';
                if (data['docType'] == '2') {
                    data['docType'] = 'Drivers License';
                }
                if (data['docIssueCountry'] == 'JM') {
                    data['docIssueCountry'] = 'JAMAICA';
                }
                else {
                    data['docIssueCountry'] = '';
                }
                if (data["firstName"] != null) {
                    this.model = {
                        'firstName': data["firstName"],
                        'lastName': data["surname"],
                        'town': data["city"],
                        'country': "7ac48140fac845b3b6febf7352061b4e",
                        'employerName': data["employerName"],
                        'parish': data["parish"],
                        'tRN': data["trn"],
                        'gender': data["gender"],//=== 'M' ? 'Male' : 'Female',
                        'nationality': '7ac48140fac845b3b6febf7352061b4e',
                        'postOfficeCode': data['postOffice'],
                        'addressLine1': data['streetNumAndName'],
                        'customerType': "Existing",
                        'mailingCountry': '7ac48140fac845b3b6febf7352061b4e',
                        'employerCountry': '7ac48140fac845b3b6febf7352061b4e',
                        'alternateContactCountry': '7ac48140fac845b3b6febf7352061b4e',
                        'iDType': data['docType'],
                        'iDNumber': data['docNumber'],
                        'placeOfIssue': data['docIssueCountry'],
                        'responseType': data['responseType'],
                        'dateOfBirth': data["dateOfBirth"] === null ? null : { year: +data["dateOfBirth"].toString().split('-')[0], month: +data["dateOfBirth"].toString().split('-')[1], day: +data["dateOfBirth"].toString().split('-')[2] },
                        //'iDExpirationDate': data["docIssueDate"] === null ? null : { year: +data["docIssueDate"].toString().split('-')[0], month: +data["docIssueDate"].toString().split('-')[1].replace('0', ''), day: +data["docIssueDate"].toString().split('-')[2].replace('0', '') },
                        'profileimage': data["photo"] === null ? null : data["photo"]
                    }
                    if (data["photo"] == null) {
                        this.imageTemplate = {
                            "className": "section-label",
                            "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img  class='custImage' style='height:235px; width:235px' src='assets/images/TRN.jpg'></div>"
                        }
                        this.template[0].sections[0].fields[0] = this.imageTemplate;

                    }
                    else {

                        this.imageTemplate = {
                            "className": "section-label",
                            "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img  class='custImage' style='height:235px; width:235px' src='data:image/png;base64," + data["photo"] + "'></div>"
                        }
                        this.template[0].sections[0].fields[0] = this.imageTemplate;
                    }
                    let warningMsg = false;
                    let errorMsg = '';
                    if (this.form.value.firstNameNew != "") {
                        if (this.model['firstName'].toLowerCase() != this.form.value.firstNameNew.toLowerCase()) {
                            warningMsg = true;
                            errorMsg = 'First Name';
                            //this.toastr.warning("Partial hit. First Name doesn't match.", null, { toastLife: 30000 });
                            // return false;
                        }
                    }
                    if (this.form.value.lastNameNew != "") {
                        if (this.model['lastName'].toLowerCase() != this.form.value.lastNameNew.toLowerCase()) {
                            warningMsg = true;
                            if (errorMsg == '') {
                                errorMsg = 'Last Name';
                            }
                            else {
                                errorMsg = errorMsg + ', Last Name';
                            }
                            //this.toastr.warning("Partial hit. Last Name doesn't match.", null, { toastLife: 30000 });
                            // return false;
                        }
                    }
                    if (this.form.value.dateOfBirthNew != "") {
                        if (this.model['dateOfBirth']['day'] != this.form.value.dateOfBirthNew["date"]['day'] || this.model['dateOfBirth']['month'] != this.form.value.dateOfBirthNew["date"]['month'] || this.model['dateOfBirth']['year'] != this.form.value.dateOfBirthNew["date"]['year']) {
                            warningMsg = true;
                            if (errorMsg == '') {
                                errorMsg = 'Date of Birth';
                            }
                            else {
                                errorMsg = errorMsg + ', Date of Birth';
                            }
                            //this.toastr.warning("Partial hit. Date of birth doesn't match.", null, { toastLife: 30000 });
                            // return false;
                        }
                    }
                    if (warningMsg) {
                        this.toastr.warning("Partial hit. " + errorMsg + "  doesn't match.", null, { toastLife: 30000 });

                    }
                    this.model.isMailingAddressSameAsAbove = "Yes";
                }
                else if (data["trn"] == null) {
                    this.toastr.error("No hit. Invalid TRN number.");
                }
            }, error => {
                // service is down code start here 
                // service is down code end here 
                if (error["message"][0].toString().indexOf('CG6') > -1) {
                    if (this.form.value.idType.toLowerCase() == "TRN".toLowerCase()) {
                        this.toastr.error('Invalid TRN number');
                    }
                    else if (this.form.value.idType.toLowerCase() == "Driving License".toLowerCase()) {
                        this.toastr.error('Invalid Driving License number');
                    }
                }
                else {
                    this.toastr.error(error["message"][0].toString());
                }
                this.IsLoaderActive = false;
                this.model = {
                }
                this.model.isMailingAddressSameAsAbove = "Yes";
                this.openTabId = 'ngb-panel-0';
            });
        }
        else if (this.productParent == "B2B") {
            if (this.form.value.B2BCompanyName == "" || this.form.value.B2BCompanyType == "" || this.form.value.B2BTrnNumber == "" || this.form.value.B2BBusinessNumber == "") {
                this.toastr.error("Please fill all the mandatory fields.");
                this.IsLoaderActive = false;
                return false;

            }
            //let data = { "TRN": this.form.value.B2BTrnNumber }
            // 
            let data = { "TRN": this.form.value.B2BTrnNumber }
            this.leadService.postB2BTRN(data).subscribe((data) => {
                this.IsLoaderActive = false;
                this.model = data;
                this.openTabId = 'ngb-panel-0';
                //   'country': c,
                if (data["trn"] != null) {
                    if (data['docType'] == '2') {
                        data['docType'] = 'Drivers License';
                    }
                    if (data['docIssueCountry'] == 'JM') {
                        data['docIssueCountry'] = 'JAMAICA';
                    }
                    else {
                        data['docIssueCountry'] = '';
                    }
                    // ithe
                    this.model = {
                        'additionalCountry': data["additionalCountry"] ? "7ac48140fac845b3b6febf7352061b4e" : data["additionalCountry"],
                        'additionalParish': data["additionalParish"],
                        'additionalPostOfficeCode': data["additionalPostOffice"],
                        "additionalStreetNumberAndName": data["additionalStreetNumAndName"],
                        'establishDate': data["establishDate"],
                        'Country': data["mainCountry"] ? "7ac48140fac845b3b6febf7352061b4e" : data["mainCountry"],
                        'Parish': data["mainParish"],
                        'addressLine1': data['streetNumAndName'],
                        'postOfficeCode': data["mainPostOffice"],
                        'tRN': data["trn"],
                        'StreetName': data["mainStreetName"],
                        'nameOfCompany': data["tradeName"],
                        'iDType': data["docType"],
                        'iDNumber': data['docNumber'],
                        'placeOfIssue': data['docIssueCountry'],
                        'firstName': data["tradeName"],
                        // 'iDExpirationDate': data["docIssueDate"] === null ? null : { year: +data["docIssueDate"].toString().split('-')[0], month: +data["docIssueDate"].toString().split('-')[1].replace('0', ''), day: +data["docIssueDate"].toString().split('-')[2].replace('0', '') },

                    }
                    let warningMsg = false;
                    var errorMsg = '';
                    if (this.form.value.B2BCompanyName != "") {
                        if (this.model['nameOfCompany'].toLowerCase() != this.form.value.B2BCompanyName.toLowerCase()) {
                            warningMsg = true;
                            errorMsg = 'Company Name';
                            //this.toastr.warning("Partial hit. First Name doesn't match.", null, { toastLife: 30000 });
                            // return false;
                        }
                    }
                    if (this.form.value.B2BCompanyType != "") {
                        //if (this.model['lastName'].toLowerCase() != this.form.value.B2BCompanyType.toLowerCase()) {
                        // warningMsg = true;
                        // if (errorMsg == '') {
                        //     errorMsg = 'Company type';
                        // }
                        // else {
                        //     errorMsg = errorMsg + ', Company type';
                        // }
                        //}
                    }

                    if (warningMsg) {
                        this.toastr.warning("Partial hit. " + errorMsg + "  doesn't match.", null, { toastLife: 30000 });

                    }

                    this.model.isMailingAddressSameAsAbove = "Yes";
                }
                else {
                    this.toastr.error("No hit. Invalid TRN number.");
                }

            }, error => {
                this.toastr.error(error["message"][0].toString());
                this.IsLoaderActive = false;
                this.model = {}
                this.model.isMailingAddressSameAsAbove = "Yes";
                this.openTabId = 'ngb-panel-0';
            });
        }

    }
    redirectHome() {
        this.isPopedUp = false;
        this.router.navigate(['']);
    }
    cancelApiCall() {
        if (this.leadId != undefined) {
            let data = {
                "CancellationReasonId": this.cancelReason,
                "Remarks": this.cancelRemarks,
                "LeadId": this.leadId,
            }
            this.leadService
                .CancelLeadApi(data)
                .subscribe((d: any) => {
                    this.isPopedUp = false;
                    this.toastr.success("Lead cancelled successfully.");
                    this.workflowLevelUpdate("salesrejected");
                    setTimeout(() => {
                        this.router.navigate(['']);
                    }, 2000);
                });
        }
        else {
            this.isPopedUp = false;
            this.toastr.error("You need to save lead before cancel.");
        }

    }
    crdithistory() {

        var dateOfBirthError = false;
        var dateOfBirthError80 = false;
        if (this.model.firstName == '') {
            this.toastr.warning("First Name Required");
            return
        }
        if (this.model.lastName == '') {
            this.toastr.warning("Last Name Required");
            return
        }
        if (this.model.dateOfBirth == '') {
            this.toastr.warning("Date of Birth Required");
            return
        }
        if (this.model.customerType == '') {
            this.toastr.warning("Customer Type Required");
            return
        }

        var patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+(co\.in|com|org|net|int|edu|gov|mil)))$/;
        if (this.model.emailAddress != null && this.model.emailAddress != "") {
            if (!this.model.emailAddress.match(patternEmail)) {
                //emailError = true;
                this.toastr.warning("Email is not valid.")
                return;
            }
        }

        if (typeof (this.model.dateOfBirth) == 'object') {
            let year = this.model.dateOfBirth["year"].toString();
            let month = this.model.dateOfBirth["month"].toString().length == 1 ? '0' + this.model.dateOfBirth["month"].toString() : this.model.dateOfBirth["month"].toString();
            let day = this.model.dateOfBirth["day"].toString().length == 1 ? '0' + this.model.dateOfBirth["day"].toString() : this.model.dateOfBirth["day"].toString();
            let date = year + '-' + month + '-' + day;
            let birthDate = new Date(date + 'T10:20:30Z');

            var today = new Date();
            //var year = +this.model.dateofBirth.split('-')[0] - today.getFullYear();                
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            else if (m === 0 && today.getDate() == birthDate.getDate()) {
                age;
            }
            else {
                age++;
            }
            if (age < 18) {
                dateOfBirthError = true;
            }
            if (age > 80) {
                dateOfBirthError80 = true;
            }
            if (typeof (this.model.dateOfBirth) == 'object') {
                this.model.dateOfBirth = (this.model.dateOfBirth["year"] + '-' + this.model.dateOfBirth["month"] + '-' + + this.model.dateOfBirth["day"]).toString()
            }
        }
        else if (typeof (this.model.dateOfBirth) == 'string' && this.model.dateOfBirth != '') {
            let year = this.model.dateOfBirth.split('-')[0].toString();
            let month = this.model.dateOfBirth.split('-')[1].toString().length == 1 ? '0' + this.model.dateOfBirth.split('-')[1].toString() : this.model.dateOfBirth.split('-')[1].toString();
            let day = this.model.dateOfBirth.split('-')[2].toString().length == 1 ? '0' + this.model.dateOfBirth.split('-')[2].toString() : this.model.dateOfBirth.split('-')[2].toString();
            let date = year + '-' + month + '-' + day;
            let birthDate = new Date(date + 'T10:20:30Z');

            var today = new Date();
            //var year = +this.model.dateofBirth.split('-')[0] - today.getFullYear();                
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            else if (m === 0 && today.getDate() == birthDate.getDate()) {
                age;
            }
            else {
                age++;
            }
            if (age < 18) {
                dateOfBirthError = true;
            }
            if (age > 80) {
                dateOfBirthError80 = true;
            }
        }
        this.creditHistoryFetch = true;
        let creditInfo = {
            firstName: this.model.firstName || '',
            lastName: this.model.lastName || '',
            tRN: this.form.value.trnNumber || '',
            docNumber: this.model.docNumber || '',
            docIssueDate: this.model.docIssueDate || '',
            dateofBirth: this.model.dateOfBirth || '',
            product: this.productName,
            subProduct: this.subproductName,
            addressLine1: this.model.addressLine1 || '',
            town: this.model.town || '',
            parish: this.model.parish || '',
            gender: this.model.gender || '',
            prevFirstName: "",
            prevSurname: "",
            middleName: "",
            countryOfBirth: ""
        }

        if (typeof (this.model.dateOfBirth) == 'object') {
            creditInfo.dateofBirth = (this.model.dateOfBirth["month"] + '/' + this.model.dateOfBirth["day"] + '/' + this.model.dateOfBirth["year"]).toString() || ''

        } else {
            creditInfo.dateofBirth = this.model.dateOfBirth
        }


        if (dateOfBirthError) {
            this.toastr.error("Please select date of birth more than 18 years");
            this.submitedData = false;
            this.NoCreditHistoryFound = true;
            this.creditHistoryFetch = false;
        }
        else if (dateOfBirthError80) {
            this.toastr.error("Please select date of birth less than 80 years");
            this.submitedData = false;
            this.NoCreditHistoryFound = true;
            this.creditHistoryFetch = false;
        }
        else {
             console.log(this.model.dateOfBirth)
            this.leadService
                .getCreditHistory(creditInfo, this.productParent)
                .subscribe((data: any) => {
                    this.creditHistoryFetch = false;
                    this.decision = data.decision;
                    this.model["decision"] = this.decision
                    this.creditScoreResponse = data.acSummary;
                    if (this.creditScoreResponse != null) {
                        this.toastr.success("Credit history fetch successfully.");
                        this.submit()
                        this.showCreditScore = true
                        this.noResult = false
                        this.NoCreditHistoryFound = false;
                    } else {
                        this.toastr.info("No Credit History found.");
                        this.submit()
                        this.noResult = true
                        this.NoCreditHistoryFound = true;
                    }
                    if (this.decision == '') {
                        this.template[1].active = false;
                    }
                }, error => {
                    this.creditHistoryFetch = false;
                    this.toastr.error("No Credit History found.");
                    this.submit();
                    this.NoCreditHistoryFound = true;
                });
        }

    }

    otpPopedUpVerified(leadId, mobile) {
        if (mobile == "") {
            // console.log(this.decision);
            // if (!this.NoCreditHistoryFound) {
            //     this.template[1].active = true;
            // }
            // if (this.decision != '') {
            //     this.template[1].active = true;
            // }
            if (this.decision != null) {
                this.template[1].active = true;
            }
        }else {
            this.otpPop = true;
        }
    }

    submitOTP() {
        if (this.otp == "" || this.otp == undefined || this.otp == null) {
            this.toastr.error("Please enter OTP");
        }
        else {
            var d = {
                "OTP": this.otp,
                "PhoneNo": this.model.mobileno,
                "LeadId": this.leadId,
                "isOTPSkipped": false
            }
            this.leadService
                .ValidateOTP(d)
                .subscribe((data: any) => {
                    this.otp = "";
                    this.toastr.success("OTP verified successfully");
                    this.otpPop = false;
                    // if (!this.NoCreditHistoryFound) {
                    //     this.template[1].active = true;
                    // }
                    // if (this.decision != '') {
                    //     this.template[1].active = true;
                    // }
                    if (this.decision != null) {
                        this.template[1].active = true;
                    }
                    this.workflowLevelUpdate("levelonesubmitted");

                }, error => {

                    this.toastr.error("Wrong/Old OTP entered");
                });
        }

    }
    cancelOTP() {
        this.otpPop = false;
        this.proceedDisabled = false;
    }
    skipOTP() {
        this.otp = "";
        this.otpPop = false;
         var inputParams = {
                "OTP": this.otp,
                "PhoneNo": this.model.mobileno,
                "LeadId": this.leadId,
                "isOTPSkipped": true
           }
        this.leadService.ValidateOTP(inputParams).subscribe((data: any) => {}, error => {});
        if (this.decision != null) {
            this.template[1].active = true;
        }
        this.workflowLevelUpdate("levelonesubmitted");
    }

    otpVerified() {
    }

    submit() {
        // delete this.model["dateOfBirth"];
        if (this.productParent == "B2B") {
            if (this.model.nameOfCompany == '') {
                this.toastr.warning("Company Name Required");
                return
            }
        }
        else {
            if (this.model.firstName == '') {
                this.toastr.warning("First Name Required");
                return
            }
        }
        if (this.model.lastName == '') {
            this.toastr.warning("Last Name Required");
            return
        }
        if (this.model.dateOfBirth == '') {
            this.toastr.warning("Date of Birth Required");
            return
        }
        if (this.model.customerType == '') {
            this.toastr.warning("Customer Type Required");
            return
        }
        var patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+(co\.in|com|org|net|int|edu|gov|mil)))$/;
        if (this.model.email != null && this.model.email != "") {
            if (!this.model.email.match(patternEmail)) {
                //emailError = true;
                this.toastr.warning("Email is not valid.")
                return false;
            }
        }

        if (this.model.email != null || this.model.email != undefined) {
            this.model.email = this.model.email
        }
        else {
            this.model.email = this.model.emailAddress
        }
        if (this.model.mobileno != null || this.model.mobileno != undefined) {
            this.model.mobileno = this.model.mobileno
        }
        else {
            this.model.mobileno = this.model.mobileNumber
        }
        delete this.model["emailAddress"]
        delete this.model["mobileNumber"]
        this.submitedData = true;
        this.model.productName = this.productName
        this.model.subproductName = this.subproductName
        this.model.subproductId = this.subProductId
        //this.model.branchPreferenceId = "1"
        this.model.productId = this.productId
        // var pattern = "^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$";
        //var patternEmail = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        var patternMobile = /^(\+91-|\+91|0)?\d{10,13}$/;
        //this.model.dateOfBirth = "1982-05-05";
        if (this.t.activeId == "Level 1") {
            let requiredError = false;
            let emailError = false;
            let mobileError = false;
            let dateOfBirthError = false;
            let dateOfBirthError80 = false;
            let idExpirationDate = false;

            if (typeof (this.model.dateOfBirth) == 'object') {
                let year = this.model.dateOfBirth["year"].toString();
                let month = this.model.dateOfBirth["month"].toString().length == 1 ? '0' + this.model.dateOfBirth["month"].toString() : this.model.dateOfBirth["month"].toString();
                let day = this.model.dateOfBirth["day"].toString().length == 1 ? '0' + this.model.dateOfBirth["day"].toString() : this.model.dateOfBirth["day"].toString();
                let date = year + '-' + month + '-' + day;
                let birthDate = new Date(date + 'T10:20:30Z');

                var today = new Date();
                //var year = +this.model.dateofBirth.split('-')[0] - today.getFullYear();                
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                else if (m === 0 && today.getDate() == birthDate.getDate()) {
                    age;
                }
                else {
                    age++;
                }
                if (age < 18) {
                    dateOfBirthError = true;
                }
                if (age > 80) {
                    dateOfBirthError80 = true;
                }
                if (typeof (this.model.dateOfBirth) == 'object') {
                    this.model.dateOfBirth = (this.model.dateOfBirth["year"] + '-' + this.model.dateOfBirth["month"] + '-' + + this.model.dateOfBirth["day"]).toString()
                }
            }
            if (typeof (this.model.iDExpirationDate) == 'object') {
                let year = this.model.iDExpirationDate["year"].toString();
                let month = this.model.iDExpirationDate["month"].toString().length == 1 ? '0' + this.model.iDExpirationDate["month"].toString() : this.model.iDExpirationDate["month"].toString();
                let day = this.model.iDExpirationDate["day"].toString().length == 1 ? '0' + this.model.iDExpirationDate["day"].toString() : this.model.iDExpirationDate["day"].toString();
                let date = year + '-' + month + '-' + day;
                let birthDate = new Date(date + 'T10:20:30Z');
                birthDate.setHours(0, 0, 0, 0);

                var now = new Date();

                now.setHours(0, 0, 0, 0);
                if (birthDate <= now) {
                    idExpirationDate = true;
                    // selected date is in the past
                }
                if (typeof (this.model.iDExpirationDate) == 'object') {
                    this.model.iDExpirationDate = (this.model.iDExpirationDate["year"] + '-' + this.model.iDExpirationDate["month"] + '-' + + this.model.iDExpirationDate["day"]).toString()
                }
            }
            if (typeof (this.model.iDExpirationDate) == 'string' && this.model.iDExpirationDate != '') {

                let year = this.model.iDExpirationDate.split('-')[0].toString();
                let month = this.model.iDExpirationDate.split('-')[1].toString().length == 1 ? '0' + this.model.iDExpirationDate.split('-')[1].toString() : this.model.iDExpirationDate.split('-')[1].toString();
                let day = this.model.iDExpirationDate.split('-')[2].toString().length == 1 ? '0' + this.model.iDExpirationDate.split('-')[2].toString() : this.model.iDExpirationDate.split('-')[2].toString();
                let date = year + '-' + month + '-' + day;
                let birthDate = new Date(date + 'T10:20:30Z');
                birthDate.setHours(0, 0, 0, 0);

                var now = new Date();

                now.setHours(0, 0, 0, 0);
                if (birthDate <= now) {
                    idExpirationDate = true;
                    // selected date is in the past
                }
                if (typeof (this.model.iDExpirationDate) == 'object') {
                    this.model.iDExpirationDate = (this.model.iDExpirationDate["year"] + '-' + this.model.iDExpirationDate["month"] + '-' + + this.model.iDExpirationDate["day"]).toString()
                }
            }
            //   console.log(!this.model.email.match(patternEmail));


            if (this.model.mobileno != null && this.model.mobileno != "") {
                if (!this.model.mobileno.match(patternMobile)) {
                    mobileError = true;
                }
            }
            else {
                mobileError = false;
            }

            for (var i = 0; i < this.template[0]['sections'].length; i++) {
                for (var j = 0; j < this.template[0]['sections'][i]["fields"].length; j++) {
                    if (this.template[0]['sections'][i]["fields"][j]['templateOptions'] != undefined) {
                        if (this.template[0]['sections'][i]["fields"][j]['templateOptions']['required'] == true) {
                            //this.requiredFieldsKey.push(this.template[0]['sections'][i]["fields"][j]['key']);
                            var keyName = this.template[0]['sections'][i]["fields"][j]['key'];
                            if (this.model[keyName] == undefined || this.model[keyName] == "" || this.model[keyName] == "Please Select") {
                                // validation change
                                this.template[0]['sections'][i]["fields"][j]['className'] = "col-xs-6 error"
                                requiredError = true;
                            }
                        }
                    }
                }
            }
            if (requiredError) {
                this.toastr.error("Please fill  all the required fields in L1.");
                this.submitedData = false;
            }
            else if (dateOfBirthError) {
                this.toastr.error("Please select date of birth more than 18 years");
                this.submitedData = false;
            }
            else if (dateOfBirthError80) {
                this.toastr.error("Please select date of birth less than 80 years");
                this.submitedData = false;
            }
            else if (idExpirationDate) {
                this.toastr.error("Id Expiry date should be greater than today.");
                this.submitedData = false;
            }
            else if (emailError) {
                this.toastr.error("Invalid email address.");
                this.submitedData = false;
            }
            else if (mobileError) {
                this.toastr.error("Invalid mobile number.");
                this.submitedData = false;
            }
            else {
                this.model["leadOriginator"] = "Browser";
                this.model["decision"] = this.decision
                var dataTab1 = {
                    "validationContext": "test",
                    "leadData": this.model,
                };
                // parent check               
                if (this.productParent == "B2B") {
                    // change update lead id
                    this.creditHistoryFetch = true;
                    dataTab1["leadData"]['firstName'] = this.model["nameOfCompany"];
                    if (this.model["contactType"] == 2) {
                        dataTab1["leadData"]['mobileno'] = this.model["contactNumber"];
                        dataTab1["leadData"]['email'] = '';
                    }
                    else if (this.model["contactType"] == 4) {
                        dataTab1["leadData"]['mobileno'] = '';
                        dataTab1["leadData"]['email'] = this.model["contactNumber"];
                    }
                    else {
                        dataTab1["leadData"]['mobileno'] = '';
                        dataTab1["leadData"]['email'] = '';
                    }
                    // this.model.dateOfBirth = "1982-05-05";
                    //TradeName: this.model.firstName.replace('&', '&amp;') || '',

                    let creditInfo = {
                        tRN: this.form.value.B2BTrnNumber || '',
                        CompanyType: this.model.typeOfCompany || '',
                        TradeName: this.model.firstName || '',
                        product: this.productName,
                        subProduct: this.subproductName,
                    }
                    this.leadService
                        .getCreditHistory(creditInfo, this.productParent)
                        .subscribe((data: any) => {
                            this.creditHistoryFetch = false;
                            this.decision = data.decision;
                            this.creditScoreResponse = data.acSummary;
                            dataTab1["leadData"].decision = data.decision;
                            if (this.creditScoreResponse != null) {
                                this.toastr.success("Credit history fetch successfully.");
                                this.showCreditScore = true
                                // this.template[1].active = true;
                                this.noResult = false
                                this.NoCreditHistoryFound = false;

                                if (!this.otpSent) {
                                    this.leadService
                                        .saveLead(dataTab1)
                                        .subscribe((d: any) => {
                                            setTimeout(() => {
                                                this.submitedData = false;
                                                this.leadId = d.message;
                                                this.model.leadId = this.leadId
                                                //this.template[1].active = true;
                                                this.template[0].active = true;
                                                //Issue here
                                                this.toastr.success("Level 1 details have been submitted successfully.");
                                                this.leadService
                                                    .GetLeadById(this.leadId)
                                                    .subscribe((data: any) => {
                                                        this.toastr.success("Application Number " + '"' + data.ApplicationNumber + '".');
                                                        this.email = data.email
                                                        this.mobile = data.mobileno
                                                        this.postLeadinfo();
                                                        this.template[1].active = true;
                                                        this.otpSent = true;
                                                        this.otpPopedUpVerified(this.leadId, this.mobile);
                                                        // ithe OTP
                                                    });
                                                //this.workflowLevelUpdate("levelonesubmitted")

                                            }, 5000);
                                        }, error => {
                                            this.toastr.error("No hit");
                                            this.toastr.error(error);
                                        });


                                }
                                else {
                                    var dataTab2 = {
                                        'id': this.leadId,
                                        "validationContext": "test",
                                        "leadData": this.model
                                    };
                                    var mobile = this.model['mobileno']
                                    this.leadService
                                        .updateLead(dataTab2)
                                        .subscribe((d: any) => {
                                            this.submitedData = false;
                                            this.template[1].active = true;
                                            this.toastr.success("Level 1 details have been updated successfully.");
                                            //this.workflowLevelUpdate("levelonesubmitted");
                                            //this.mobile
                                            this.otpPopedUpVerified(this.leadId, mobile);
                                            this.otpSent = true;
                                            this.leadService
                                                .ReSendOtp(this.leadId)
                                                .subscribe((d: any) => {
                                                    this.workflowLevelUpdate("levelonesubmitted");
                                                });
                                        }, error => {
                                            this.toastr.error("Something went wrong.");
                                        });
                                }

                            } else {
                                this.NoCreditHistoryFound = true;
                                this.toastr.error("No Credit History found.");
                                this.template[1].active = false;
                                this.noResult = true


                                if (!this.otpSent) {
                                    this.leadService
                                        .saveLead(dataTab1)
                                        .subscribe((d: any) => {
                                            setTimeout(() => {
                                                this.submitedData = false;
                                                this.leadId = d.message;
                                                this.model.leadId = this.leadId
                                                //this.template[1].active = true;
                                                this.template[0].active = true;
                                                //Issue here
                                                this.toastr.success("Level 1 details have been submitted successfully.");
                                                this.leadService
                                                    .GetLeadById(this.leadId)
                                                    .subscribe((data: any) => {
                                                        this.toastr.success("Application Number " + '"' + data.ApplicationNumber + '".');
                                                        this.email = data.email
                                                        this.mobile = data.mobileno
                                                        this.postLeadinfo();
                                                        this.template[1].active = true;
                                                        this.otpSent = true;
                                                        this.otpPopedUpVerified(this.leadId, this.mobile);
                                                        // ithe OTP
                                                    });
                                                //this.workflowLevelUpdate("levelonesubmitted")

                                            }, 5000);
                                        }, error => {
                                            this.toastr.error("No hit");
                                            this.toastr.error(error);
                                        });


                                }
                                else {
                                    var dataTab2 = {
                                        'id': this.leadId,
                                        "validationContext": "test",
                                        "leadData": this.model
                                    };
                                    var mobile = this.model['mobileno']
                                    this.leadService
                                        .updateLead(dataTab2)
                                        .subscribe((d: any) => {
                                            this.submitedData = false;
                                            this.template[1].active = true;
                                            this.toastr.success("Level 1 details have been updated successfully.");
                                            //this.workflowLevelUpdate("levelonesubmitted");
                                            //this.mobile
                                            this.otpPopedUpVerified(this.leadId, mobile);
                                            this.otpSent = true;
                                            this.leadService
                                                .ReSendOtp(this.leadId)
                                                .subscribe((d: any) => {
                                                    this.workflowLevelUpdate("levelonesubmitted");
                                                });
                                        }, error => {
                                            this.toastr.error("Something went wrong.");
                                        });
                                }


                                return false;
                            }
                            if (this.decision == '') {
                                this.template[1].active = false;
                            }
                            if (this.decision == null) {
                                this.template[1].active = false;
                            }
                        }, error => {
                            this.NoCreditHistoryFound = true;
                            this.creditHistoryFetch = false;
                            this.template[1].active = false;
                            this.toastr.error("No hit. No Credit History found.");
                            return false;
                        });
                }
                this.proceedDisabled = true
                // level1 save 
                dataTab1["leadData"]['level'] = "levelone";

                if (this.productParent != "B2B") {
                    if (!this.otpSent) {
                        this.leadService
                            .saveLead(dataTab1)
                            .subscribe((d: any) => {
                                setTimeout(() => {
                                    this.submitedData = false;
                                    this.leadId = d.message;
                                    this.model.leadId = this.leadId
                                    //this.template[1].active = true;
                                    this.template[0].active = true;
                                    //Issue here
                                    this.toastr.success("Level 1 details have been submitted successfully.");
                                    this.leadService
                                        .GetLeadById(this.leadId)
                                        .subscribe((data: any) => {
                                            this.toastr.success("Application Number " + '"' + data.ApplicationNumber + '".');
                                            this.email = data.email
                                            this.mobile = data.mobileno
                                            this.postLeadinfo();
                                            this.template[1].active = true;
                                            this.otpSent = true;
                                            this.otpPopedUpVerified(this.leadId, this.mobile);
                                            // ithe OTP
                                        });
                                    //this.workflowLevelUpdate("levelonesubmitted")

                                }, 5000);
                            }, error => {
                                this.toastr.error("No hit");
                                this.toastr.error(error);
                            });


                    }
                    else {
                        var dataTab2 = {
                            'id': this.leadId,
                            "validationContext": "test",
                            "leadData": this.model
                        };
                        var mobile = this.model['mobileno']
                        this.leadService
                            .updateLead(dataTab2)
                            .subscribe((d: any) => {
                                this.submitedData = false;
                                 this.template[1].active = true;
                                this.toastr.success("Level 1 details have been updated successfully.");
                                //this.workflowLevelUpdate("levelonesubmitted");
                                //this.mobile
                                this.otpPopedUpVerified(this.leadId, mobile);
                                this.otpSent = true;
                                this.leadService
                                    .ReSendOtp(this.leadId)
                                    .subscribe((d: any) => {
                                        this.workflowLevelUpdate("levelonesubmitted");
                                    });
                            }, error => {
                                this.toastr.error("Something went wrong.");
                            });
                    }
                }
            }
        }
        else if (this.t.activeId == "Level 2") {
            let requiredError = false;
            for (var i = 0; i < this.template[1]['fields'].length; i++) {
                if (this.template[1]['fields'][i]['templateOptions'] != undefined) {
                    if (this.template[1]["fields"][i]['templateOptions']['required'] == true) {
                        var keyName = this.template[1]["fields"][i]['key'];
                        if (this.model[keyName] == undefined || this.model[keyName] == "") {
                            requiredError = true;
                            this.template[1]["fields"][i]['className'] = "col-xs-6 error"
                        }
                    }
                }
            }
            if (requiredError) {
                this.toastr.error("Please fill  all the required fields in L2.");
                this.submitedData = false;
            }
            else {
                this.model["leadOriginator"] = "Browser";
                this.model["decision"] = this.decision
                var dataTab2 = {
                    'id': this.leadId,
                    "validationContext": "test",
                    "leadData": this.model
                };
                if (this.model.dateHired) {
                    if (typeof (this.model.dateHired) == 'object') {
                        this.model.dateHired = (this.model.dateHired["year"] + '-' + this.model.dateHired["month"] + '-' + + this.model.dateHired["day"]).toString()
                    }
                }
                if (this.model.dateTerminated) {
                    if (typeof (this.model.dateTerminated) == 'object') {
                        this.model.dateTerminated = (this.model.dateTerminated["year"] + '-' + this.model.dateTerminated["month"] + '-' + + this.model.dateTerminated["day"]).toString()
                    }
                }
                this.model.leadId = this.leadId
                // level 2 save
                this.model.email = this.email
                this.model.mobileno = this.mobile
                dataTab2["leadData"]['level'] = "leveltwo";
                this.leadService
                    .updateLead(dataTab2)
                    .subscribe((d: any) => {
                        this.submitedData = false;
                        this.template[2].active = true;
                        this.toastr.success("Level 2 details have been submitted successfully.");
                        this.workflowLevelUpdate("leveltwosubmitted")
                    }, error => {
                        this.toastr.error("Something went wrong.");
                    });
            }
        }
        else if (this.t.activeId == "Level 3") {
            let requiredError = false;
            for (var i = 0; i < this.template[2]['fields'].length; i++) {
                if (this.template[2]['fields'][i]['templateOptions'] != undefined) {
                    if (this.template[2]["fields"][i]['templateOptions']['required'] == true) {
                        var keyName = this.template[2]["fields"][i]['key'];
                        if (this.model[keyName] == undefined || this.model[keyName] == "") {
                            requiredError = true;
                            this.template[2]["fields"][i]['className'] = "col-xs-6 error"
                        }
                    }
                }
            }
            if (requiredError) {
                this.toastr.error("Please fill  all the required fields in L3.");
                this.submitedData = false;
            }
            else {
                this.model["leadOriginator"] = "Browser";
                this.model["decision"] = this.decision
                var dataTab3 = {
                    'id': this.leadId,
                    "validationContext": "test",
                    "leadData": this.model
                };
                if (this.model.dateHired) {
                    if (typeof (this.model.dateHired) == 'object') {
                        this.model.dateHired = (this.model.dateHired["year"] + '-' + this.model.dateHired["month"] + '-' + + this.model.dateHired["day"]).toString()
                    }
                }
                if (this.model.dateTerminated) {
                    if (typeof (this.model.dateTerminated) == 'object') {
                        this.model.dateTerminated = (this.model.dateTerminated["year"] + '-' + this.model.dateTerminated["month"] + '-' + + this.model.dateTerminated["day"]).toString()
                    }
                }
                this.model.leadId = this.leadId
                this.model.email = this.email
                this.model.mobileno = this.mobile
                // level 3 submit
                dataTab3["leadData"]['level'] = "levelthree";
                this.leadService
                    .updateLead(dataTab3)
                    .subscribe((d: any) => {
                        this.submitedData = false;
                        this.docActive = true;
                        this.documentsEnable = true
                        this.toastr.success("Level 3 details have been submitted successfully.");
                        this.workflowLevelUpdate("levelthreesubmitted")
                    }, error => {
                        this.toastr.error("Error in adding lead");
                    });
            }
        }
        else if (this.t.activeId == "Upload Media") {
            var dataTab4 = {
                "leadId": this.leadId,
                "profileIdentifications": this.profileIdentifications,
                "documentStatus": 'completed'//"UploadCompleted"
            }
            if (this.productParent == "Retail") {
                var requiredError = false;
                for (var j = 0; j < this.documentArray['fields'].length; j++) {
                    if (this.documentArray['fields'][j]['templateOptions']['required'] == true) {
                       var temp =  this.findObjectByKey(this.profileIdentifications,"identificationTypeId",this.documentArray['fields'][j]["key"])
                        if(temp==null){
                             requiredError = true;
                         }
                    }
                }
                //upload document submit
                if (!requiredError) {
                    this.leadService
                        .updateLeadDocuments(dataTab4)
                        .subscribe((d: any) => {
                            this.toastr.success("Upload Media have been submitted successfully.");
                            this.submitedData = false;
                            // this.leadId = d.message;
                            // setTimeout(() => {    //<<<---    using ()=> syntax
                            //     this.router.navigate(['']);
                            // }, 2000);
                            // this.workflowLevelUpdate("level3submitted")
                            this.workflowSetup()
                        }, error => {
                            this.toastr.error("Filename should not contain special characters");
                        });
                }
                else {
                        console.log(1000)
                    this.toastr.error("Please upload all the mandatory documents.")
                }
            }else if (this.profileIdentifications.length > 4 && this.productParent == "B2B") {
                this.leadService
                    .updateLeadDocuments(dataTab4)
                    .subscribe((d: any) => {
                        this.toastr.success("Upload Media have been submitted successfully.");
                        this.submitedData = false;
                        // this.leadId = d.message;
                        // setTimeout(() => {    //<<<---    using ()=> syntax
                        //     this.router.navigate(['']);
                        // }, 2000);
                        this.workflowSetup()
                    }, error => {
                        this.toastr.error("Error in adding lead.");
                    });
            }
            else {
                console.log(1000)
                this.submitedData = false;
                this.toastr.error("Please upload all the documents.")
            }
        }
    }
    findObjectByKey(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return true;
            }
        }
        return null;
    }

    previewFile(key) {
        let documentExist = false;
        if (this.profileIdentifications.length > 0) {
            for (var i = 0; i < this.profileIdentifications.length; i++) {
                if (this.profileIdentifications[i]["identificationDocTypeId"] == key) {
                    documentExist = true;
                    var imagetype = this.profileIdentifications[i]['fileName'].substr(this.profileIdentifications[i]['fileName'].length - 3);
                    this.leadService
                        .filePreview(this.profileIdentifications[i]['fileName'])
                        .subscribe(res => {
                            if (imagetype == "pdf") {
                                var mediaType = 'application/pdf';
                            } else {
                                var mediaType = 'image/jpeg';
                            }
                            var file = new Blob([res.blob()], { type: mediaType });
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(file);
                            } else {
                                let url = window.URL.createObjectURL(file);
                                window.open(url);
                            }
                        });
                }
            }
        }
    }
    cancel() {
        this.isPopedUp = false;
    }
    cancleClick() {
        this.isPopedUp = true;
    }
    search(nameKey, myArray) {
        for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].name === nameKey) {
                return myArray[i];
            }
        }
    }
    postLeadinfo() {
        this.leadService
            .postUpdateLeadId(this.leadId)
            .subscribe((d: any) => {

            }, error => {
                this.toastr.error("Error in adding lead.");
            });
    }
    addFileToDocument(docKey, event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            var fileSize = file.size / 1024;
            var fileSizeInMB = fileSize / 1000;

            var fileName = file.name;
            var fileNameString = /^[a-z0-9-.]+$/i.test(fileName);
            if (fileNameString) {
                if (fileSizeInMB < 2) {
                    const fd: FormData = new FormData();
                    fd.append('file', file);
                    this.leadService
                        .uploadFile(fd)
                        .subscribe(data => {
                            for (var i = 0; i < this.profileIdentifications.length; i++) {
                                if (this.profileIdentifications[i]['identificationTypeId'] == docKey) {
                                    this.profileIdentifications.splice(i, 1);
                                }
                            }
                            let obj = {
                                "id": "",
                                "path": data["path"],
                                "fileName": data["fileName"],
                                "identificationTypeId": docKey,
                                "identificationDocTypeId": docKey,
                                "identificationDocId": "",
                                "deferredTillDate": "",
                                "isDeferred": "",
                                "IsWavedOff": "",
                                "isDelete": "false",
                                "tflexId": this.leadId
                            };
                            this.profileIdentifications.push(obj);

                        }, error => {
                            this.toastr.error("Filename should not contain special characters");
                        });

                    if (docKey == "tRNDocument") {
                        this.trnDocumentName = file["name"];
                    }
                    if (docKey == "passportDocument") {
                        this.passportDocumentName = file["name"];
                    }
                    if (docKey == "utilityBillDocument") {
                        this.utilityBillDocumentName = file["name"];
                    }
                    if (docKey == "jobLetter") {
                        this.jobLetterDocumentName = file["name"];
                    }
                    if (docKey == "iDProFirAuthSig") {
                        this.idProofFirstAuthorizedSignatoryName = file["name"];
                    }
                    if (docKey == "iDProSecAuthSig") {
                        this.idProofSecondAuthorizedSignatoryName = file["name"];
                    }
                    if (docKey == "signedConsent") {
                        this.signedConsentName = file["name"];
                    }
                    if (docKey == "companyTRN") {
                        this.companyTRNName = file["name"];
                    }
                    if (docKey == "companyRegistrationDoc") {
                        this.CompanyRegistrationDocName = file["name"];
                    }
                    if (docKey == "certificateOfIncorporation") {
                        this.CertificateofIncorporationName = file["name"];
                    }
                    if (docKey == "iDOfPrimaryApplicant") {
                        this.IDofprimaryapplicantName = file["name"];
                    }
                    if (docKey == "signedConsentForm") {
                        this.SignedConsentFormName = file["name"];
                    }
                }
                else {
                    this.toastr.error("File size should not be greater than 2 MB.");
                }
            }
            else {
                this.toastr.error("File name should not contain special characters and spaces.");
            }
        }
    }
    tabClick(activeId) {

        if (activeId == "Level 1") {
            this.tabButtonTitle = "Proceed";
            this.activeTabId = activeId;
            this.showCreditInfoButton = true
        }
        else if (activeId == "Upload Media") {
            this.leveloneSubmitted = false
            this.proceedDisabled = false
            this.tabButtonTitle = "Save";
            this.activeTabId = activeId;
            this.showCreditInfoButton = false
        }
        else {
            this.leveloneSubmitted = true
            this.proceedDisabled = false
            this.tabButtonTitle = "Save";
            this.activeTabId = activeId;
            this.showCreditInfoButton = false
        }


        // let id = activeId.split('-')[2];
        // if (id < 4) {
        //     if (id != "0" && this.model.leadId) {
        //         this.leveloneSubmitted = true
        //         this.proceedDisabled = false
        //         this.tabButtonTitle = "Save";
        //         this.activeTabId = activeId;
        //         this.showCreditInfoButton = false
        //     } else {
        //         this.tabButtonTitle = "Proceed";
        //         this.activeTabId = activeId;
        //         this.showCreditInfoButton = true
        //     }
        // }
        // else {
        //     if (id % 4 == 0) {
        //         this.proceedDisabled = false
        //         this.tabButtonTitle = "Save";
        //         this.activeTabId = activeId;
        //         this.showCreditInfoButton = false
        //     }
        //     else {
        //         let mod = id % 4;
        //         this.tabButtonTitle = "Proceed";
        //         this.activeTabId = "ngb-tab-" + mod;
        //         this.showCreditInfoButton = true

        //     }
        // }

    }
    workflowSetup() {
        if (this.productParent == 'Retail' && this.model.subproductName == 'Prepaid') {
            this.workflowLevelUpdate("loggedin")
        } else if (this.decision == "Accept") {
            this.workflowLevelUpdate("loggedin")
        } else if (this.decision == "rejected") {
            this.workflowLevelUpdate("salesrejected")
        } else if (this.decision == "Refer") {
            this.workflowLevelUpdate("referred")
        }
    }
    workflowLevelUpdate(data) {
        let leadinfo = {
            ApplicationStatus: data,
            AssignTo: "",
            NextApplicationStatus: "",
            NextActionDate: new Date(),
            Remarks: "",
            LeadId: this.leadId
        }
        this.leadService
            .workflowLeadLevelUpdate(leadinfo)
            .subscribe((d: any) => {

            }, error => {
                this.toastr.error("Error in adding lead.");
            });
    }
    
}



// WEBPACK FOOTER //
// ./src/app/lead/add-lead/add-lead.component.ts